import React from 'react'
import './Nav.css'

import { Link } from 'react-router-dom'
import { translate } from 'react-i18next'

import { MenuSvg } from './SVGarr'


class Nav extends React.Component {
	constructor(props) {
		super(props)
		this.state = { isOpened: false }

		this.toggelState = this.toggelState.bind(this)
	}

	toggelState() {
		this.setState({ isOpened: !this.state.isOpened })
	}

  render() {
		let dropdaunText;
		if (this.state.isOpened) {
			dropdaunText =	<ul> 
												<li><Link to='/'> {this.props.t('menu1')} </Link></li>
												<li><Link to='/about'> {this.props.t('menu3')} </Link></li>
												<li><Link to='/contact'> {this.props.t('menu4')} </Link></li>
											</ul>
		}
    return (
			<nav>
				<Link className="linkMenu" onClick={this.toggelState} to="#">{MenuSvg}</Link>
				{dropdaunText}
			</nav>
    )
  } 
}

export default translate('translations')(Nav)


// WEBPACK FOOTER //
// ./src/components/Nav.jsx